import { Routes, Route, useNavigate } from "react-router-dom";
import FDForm from "./FDForm";
import RDForm from "./RDForm";
import InvestmentList from "./InvestmentList";

export default function Investments(){

  const nav = useNavigate();

  return (
    <div style={{ padding:"20px" }}>

      <div style={{ marginBottom:"20px", display:"flex", gap:"10px" }}>
        <button className="btn btn-primary" onClick={()=>nav("fd")}>+ FD</button>
        <button className="btn btn-primary" onClick={()=>nav("rd")}>+ RD</button>
        <button className="btn btn-secondary" onClick={()=>nav("list")}>All Investments</button>
      </div>

      <Routes>
        <Route path="fd" element={<FDForm />} />
        <Route path="rd" element={<RDForm />} />
        <Route path="list" element={<InvestmentList />} />
      </Routes>

    </div>
  );
}
